import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './../context/AuthContext';

export function ProtectedRoute({ children, allow  }) {
    const { token, userType } = useAuth();
    const location = useLocation();

    if (!token) {
        return <Navigate to={`/login`} state={{ from: location }} replace />;
    }

      if (Array.isArray(allow) && allow.length > 0) {
    if (!allow.includes(userType)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

    return children;
}
export default ProtectedRoute;
